import * as GSAP from 'gsap';
import AbstractView = require("../abstract/AbstractView");
import Config = require("../../config/Config");


class TabItem extends AbstractView {

    constructor(template: JQuery) {
        super(template);
    }


    init(): void {
    }

    reset(): void {
        this.resetContent();
    }


    private $title: JQuery;
    private $label: JQuery;
    private $desc: JQuery;
    private $animateCon: JQuery;

    public createContent(): void {

        this.$title = this.$template.find(".info-title");
        this.$label = this.$template.find(".info-label");
        this.$desc = this.$template.find(".info-desc");

        this.$animateCon = this.$template.find(".animateCon");
        this.resetContent();
    }

    public resetContent(): void {

        let tx: number = 100;
        if (this._direction == "Row") {
            tx = -1 * tx;
        }

        let text_tx: number = 40;
        GSAP.TweenMax.set(this.$animateCon, {
            x: tx + "%",
            alpha: 0
        });
        GSAP.TweenMax.set(this.$title, {
            y: text_tx + "%",
            alpha: 0
        });
        GSAP.TweenMax.set(this.$label, {
            y: text_tx + "%",
            alpha: 0
        });
        GSAP.TweenMax.set(this.$desc, {
            y: text_tx + "%",
            alpha: 0
        });
    }


    private $video: any;
    private $videoCon: JQuery;
    private $videoCover: JQuery;

    public createVideo(): void {
        this.$videoCon = this.$template.find(".videoCon");
        this.$video = this.$videoCon.find(".video");
        this.$videoCover = this.$videoCon.find(".cover");
        this.$video.get(0).load();
        this.$video.on("loadedmetadata", (event: JQuery.Event) => {
            if (!Config.checkMobileDevice()) {
                this.$videoCover.removeClass("active");
            }
        });
    }


    private _direction: string;
    public set direction(d: string) {
        this._direction = d;
    }


    onTransitionComplete(type: string, id?: number): void {
        if (type == AbstractView.Events.ON_TRANSITION_IN_COMPLETE) {

            if (this.$video) {
                if (!Config.checkMobileDevice()) {
                    this.$video.get(0).play();
                }
            }

            GSAP.TweenMax.to(this.$animateCon, 0.5, {
                x: "0%",
                alpha: 1,
                ease: GSAP.Circ.easeOut
            });
            GSAP.TweenMax.to(this.$title, 1, {
                delay: 0.3,
                y: "0%",
                alpha: 1,
                ease: GSAP.Circ.easeOut
            });
            GSAP.TweenMax.to(this.$label, 1, {
                delay: 0.3,
                y: "0%",
                alpha: 1,
                ease: GSAP.Circ.easeOut
            });
            GSAP.TweenMax.to(this.$desc, 1, {
                delay: 0.5,
                y: "0%",
                alpha: 1,
                ease: GSAP.Circ.easeOut
            });
        }
        if (type == AbstractView.Events.ON_TRANSITION_OUT_COMPLETE) {
            if (this.$video) this.$video.get(0).pause();
        }
        super.onTransitionComplete(type, id);
    }
}

export = TabItem;